import { render, staticRenderFns } from "./RziJoinedTable.vue?vue&type=template&id=5a06c17a&scoped=true&"
import script from "./RziJoinedTable.vue?vue&type=script&lang=js&"
export * from "./RziJoinedTable.vue?vue&type=script&lang=js&"
import style0 from "./RziJoinedTable.vue?vue&type=style&index=0&id=5a06c17a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a06c17a",
  null
  
)

export default component.exports